export enum SplitComponentEnum {
    LegalizationDetails = 1,
    AgreementAnnexDetails = 2,
    AnnexFilePreview = 3,
    WorkerAgreementDetailsPanel = 4,
    AnnexDetailsPanel = 5
}